import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import './styles/index.css'
import './utils/fullHeight'

ReactDOM.render(<App />, document.querySelector('#root'))
